module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paged-list"
  }, [_c('Table', {
    ref: "table",
    staticClass: "list",
    attrs: {
      "stripe": _vm.stripe,
      "border": "",
      "columns": _vm.columns,
      "data": _vm.list,
      "highlight-row": _vm.highlight,
      "show-header": _vm.showHeader,
      "loading": _vm.loading
    },
    on: {
      "on-selection-change": _vm.onChangeSelection,
      "on-row-click": _vm.onclickRow,
      "on-sort-change": _vm.sortCange
    }
  }, [_c('div', {
    staticClass: "spin-container",
    attrs: {
      "slot": "loading"
    },
    slot: "loading"
  }, [_c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "spin-icon-load",
    attrs: {
      "type": "ios-loading",
      "size": "48"
    }
  })], 1)], 1), _vm._v(" "), (_vm.footerShow) ? _c('div', {
    staticClass: "spin-container",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._t("footerData")], 2) : _vm._e()]), _vm._v(" "), (_vm.pageList) ? _c('div', {
    style: (_vm.pageFloat)
  }, [_c('Page', {
    staticClass: "page",
    attrs: {
      "total": _vm.total,
      "current": _vm.page.page,
      "page-size": _vm.page.size,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": "",
      "page-size-opts": _vm.pageSize
    },
    on: {
      "on-change": _vm.onChangePage,
      "on-page-size-change": _vm.onChangePageSize
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0882b889","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PagedList.vue
// module id = 661
// module chunks = 120